$(document).ready(function(){
  var elem = document.querySelector('.devExperienceSlider');
  var flkty = new Flickity( elem, {
      cellAlign: 'left',
      contain: true,
      pageDots: false
  });


  $('.dev_continueShipping button').on('click', function(){
    $('.dev_closeCart').trigger('click');
  });

  var live_url = window.location.href;
  var result = live_url.includes('form_type=customer');
  var input_val = document.querySelector('#ContactSubscribe-email').value.length;
  
    console.log(result);
  if(result == true && input_val > 0 ){
    $('.devAlredySubscribe').show();
  }
   else{
    $('.devAlredySubscribe').hide();
   } 
});